export const ProductName = ({
  className = '',
  collectionName,
  displayName,
  modelName,
}: {
  className?: string;
  collectionName?: string;
  displayName: string;
  modelName: string;
}) => (
  <div className={className}>
    <h1 data-pagefind-meta="product_title">
      {collectionName ? displayName : modelName}
    </h1>
    <h2 data-pagefind-meta="product_collection">{collectionName ?? ''}</h2>
  </div>
);
